// extracted by mini-css-extract-plugin
module.exports = {"time":"TimerPage_time__14Pdo","red":"TimerPage_red__3xcMK","control":"TimerPage_control__24dO9"};